import { i18n } from 'i18n'
import { getLang } from 'i18n/config/LanguageDetector'
import { load, save } from 'util/storage'

export const INCH = 2.54

export type LengthUnit = 'cm' | 'in'

export function saveUnit(unit: LengthUnit) {
  save('unit', unit)
}

export function loadUnit(): LengthUnit {
  if (!showUnits()) return 'cm'
  return load('unit') as LengthUnit || 'cm'
}

export function showUnits() {
  return getLang() !== 'ru'
}

export function getUnitValue(value: number, unit: LengthUnit): string {
  const n = unit === 'cm' ? value : Math.round(value / INCH)
  return n.toFixed()
}

export function getUnitLabel(count: number, unit: LengthUnit): string {
  if (unit === 'in') return i18n('unit.In', { count })
  return i18n('unit.Cm', { count })
}
